import {
  Box,
  Container,
  Grid,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import { LANDING_PAGE_URL } from "config/Configuration";
import Notification from "./Notification";
import SideMenuDrawer from "./SideMenuDrawer";
import { useSelector } from "react-redux";
import primaryLogo from "assets/logo/primaryTypographyLogo.png";
import secondaryLogo from "assets/logo/secondaryTypographyLogo.png";
import { useMemo, useState } from "react";

export function FixedAppBar() {
  const theme = useTheme();
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);

  const latestNotifications = useSelector(
    (state) => state.notification.latestNotifications?.data
  );

  const logoTheme = useMemo(() => {
    const logoObject = {
      primary: primaryLogo,
      secondary: secondaryLogo,
      info: primaryLogo,
    }
    
    return logoObject[theme.mode]
    
  },[theme])

  return (
    <AppBarStyle position="fixed">
      <Container>
        <Grid container alignItems="center" my={1}>
          <Grid item xs={2} textAlign="left">
            <IconButton color="text" onClick={() => setOpenSideMenu(true)}>
              <ion-icon name="menu-outline"></ion-icon>
            </IconButton>
          </Grid>

          <Grid item xs={8} textAlign="center">
            <BoxLogo>
              <a href={LANDING_PAGE_URL}>
              <img src={logoTheme} alt="typography-logo" />
              </a>
            </BoxLogo>
          </Grid>

          <Grid item xs={2} textAlign="right">
            <IconButton color="text" onClick={() => setOpenNotification(true)}>
              {" "}
              <ion-icon name="notifications-outline"></ion-icon>
            </IconButton>
            <TypographyBadge component="span" variant="subtitle1">
              {latestNotifications?.unreadCount || 0}
            </TypographyBadge>
          </Grid>
        </Grid>
      </Container>

      <SideMenuDrawer
        open={openSideMenu}
        onClose={() => setOpenSideMenu(false)}
      />

      <Notification
        open={openNotification}
        onClose={() => setOpenNotification(false)}
      />
    </AppBarStyle>
  );
}

const AppBarStyle = styled(AppBar)(({ theme }) => ({
  maxHeight: "50px",
  boxShadow: "0 4px 8px rgb(2 51 103 / 10%)",
  background: theme.palette.modules.navbar,
}));

const BoxLogo = styled(Box)(({ theme }) => ({
  a: {
    maxWidth: "120px",
    display: "flex",
    margin: "auto",
    
    img: {
      maxWidth: '120px',
      height: "auto"
    }
  },
}));

const TypographyBadge = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.modules.backgroundBadge,
  position: "absolute",
  borderRadius: "50%",
  right: "10px",
  minWidth: "20px",
  textAlign: "center",
}));

export default FixedAppBar;
